<template>
  <section class="home-allubum">
    <v-container>
      <v-row>
        <v-col>
          <div class="section__title">
            <div class="section__title-text">写真館</div>
          </div>
        </v-col>
      </v-row>
      <v-row class="home-allubum__contents">
        <v-col  class="home-allubum__contents-img">
          <img class="home-allubum__contents-img-item" src="../assets/img/home-allubum.webp" />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="home-allubum__contents-text">
          <p class='text-h6'>たくさんの思いがつまった松尾中学校の校舎の画像をご覧になれます。</p>
        </v-col>
      </v-row>
      <AppButton 
        :button-text="buttonText" 
        :url="url"/>
    </v-container>
  </section>
</template>
<script>
import AppButton from './AppButton.vue'
export default {
  name: 'HomeAllubum',
  data () {
    return {
      buttonText: '詳しくみる',
      url: '/allubum'
    }
  },
  components: {
    AppButton
  }
}
</script>
<style  lang="scss" scoped>
@import '../styles/common/common.scss';

.section__title-text {
  margin-top: 50px;
  padding: 1rem 2rem;
  border-top: 3px solid #000;
  border-bottom: 3px solid #000;
  text-align:  center;
}
.home-allubum__contents {
  margin-top: 20px;
  justify-content: center;
  &-img {
    text-align: center;
    &-item {
      max-width: 70%;
    }
  }
  &-text {
    word-wrap: break-word;
    text-align: center;
  }
}
</style>